/**
 * Enrollments feature auto-registration and exports
 *
 * This module automatically registers the enrollments feature when imported,
 * enabling management of payer enrollments for billing entities.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { enrollmentsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(enrollmentsFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';
